<template>
    <div class="tab-pane params" id="video" role="tabpanel" aria-expanded="false">
        <div class="row section-video-row" v-if="productInfo.ProductMedias != null && productInfo.ProductMedias.length > 0">
            <section v-for="productMedia in productInfo.ProductMedias" class="col-lg-3 col-sm-6 col-md-6 col-xs-12">
                <iframe :src="productMedia.URL" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></iframe>
            </section>
        </div>

        <div v-else class="row">
            <section class="empty-media col-lg-12">
                <p class="text-center">ویدیو یی برای این محصول ثبت نشده است</p>
            </section>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            productInfo: {
                type: Object,
            },
        },
    }
</script>

<style scoped>
    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .empty-media p {
            font-size: 13px;
        }
        .section-video-row {
            text-align: center;
        }
    }
</style>